<h3 class="workspace-title">
  @if (isArchivePage) {
    <span i18n="@@my-archive">Archiv</span>
  } @else if (isTrashPage) {
    <span i18n="@@my-trash">Papierkorb</span>
  } @else if (project; as currentProject) {
    <a class="workspace-title-link" [routerLink]="['/', 'bot-admin']" i18n="@@my-projects">Projekte</a>
    @if (showMandant) {
      <i class="ri-arrow-right-s-line text-muted" aria-hidden="true"></i>
      <a class="workspace-title-link" [routerLink]="['/', 'bot-admin']"
        [queryParams]="{ org: currentProject.orgShort }">{{currentProject.orgShort}}</a>
    }
    <i class="ri-arrow-right-s-line text-muted" aria-hidden="true"></i>
    <span>{{currentProject | projectName}}</span>
  } @else {
    <span i18n="@@my-projects">Projekte</span>
  }
</h3>
